export const inputCss =
  "h-9 rounded-md text-sm px-4 py-2 " + //
  "bg-white dark:bg-her-darkblue2 dark:text-white " +
  "border ";

export const selectCss =
  "h-9 rounded-md text-sm px-4 " + //
  "bg-white dark:bg-her-darkblue2 dark:text-white ";
